/** @format */
export const PriceRerankLevel = {
	HIGH_PRICE_RERANKING : 'high-price-reranking'
};